import axios from "axios";
window._ = import("lodash");

import { createApp } from "vue";
import { Vue3OrgChartPlugin } from "vue3-org-chart";
import "vue3-org-chart/dist/style.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue"; // Uncommented
import router from "./router";
// import config from "./config";
import { createPinia } from "pinia"; // Import createPinia
import { useAuthStore } from "./store/auth"; // Import auth store
import localforage from "localforage";
import { isEmpty } from "lodash";
import { safeHtml, secureArchiveFileUrl, secureLetterAttachmentUrl, secureLetterFileUrl } from "@/helpers";

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;
axios.defaults.baseURL = import.meta.env.VITE_BASE_URL || "/";
axios.defaults.withCredentials = true;

try {
    window.Popper = import("popper.js").default;
} catch (e) {
    console.log("bootstarp js Error: ", e);
}

localforage.config({
    driver: localforage.LOCALSTORAGE,
    storeName: "HopeSoft",
});

import App from "./components/App.vue";

const app = createApp(App);
const pinia = createPinia(); // Create Pinia instance
app.use(pinia); // Use Pinia

app.directive("safe-html", {
    beforeMount(el, binding) {
        el.innerHTML = safeHtml(binding.value);
    },
    updated(el, binding) {
        el.innerHTML = safeHtml(binding.value);
    },
});
app.mixin({
    methods: {
        secureArchiveFileUrl,
        secureLetterAttachmentUrl,
        secureLetterFileUrl,
    },
});

// Initialize auth store
const authStore = useAuthStore();
authStore.initializeAuth();

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    // Uncommented
    app.component(key, component);
}

app.use(ElementPlus, { size: "large", zIndex: 3000 });
app.use(router);
// app.use(store); // This line can be removed or commented out if not using Vuex
app.use(Vue3OrgChartPlugin);

// Add an Axios interceptor for 401 Unauthorized responses
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const authStore = useAuthStore(); // Get store instance
            authStore.clearAuthState();
            window.location.href = "/";
        }
        return Promise.reject(error);
    },
);

// Implement global jQuery AJAX setup for DataTable.net authentication
// This assumes jQuery is available globally as $
if (window.jQuery) {
    const authStore = useAuthStore(); // Get store instance

    $.ajaxSetup({
        statusCode: {
            401: function () {
                authStore.clearAuthState();
                window.location.href = "/";
            },
        },
    });
}

// app.mount("#app");
router.isReady().then(() => app.mount("#app"));
// router.isReady().then(() => app.mount("#app"));
